Leikskolagjold = window.Leikskolagjold || {};

Leikskolagjold.hours = 0;
Leikskolagjold.children = 0;
Leikskolagjold.skipBreakfast = false;
Leikskolagjold.subsidized = false;

Leikskolagjold.const = {
	hourCostNormal: 4401,
	hourCostSubsidized: 3301,
	minimumHours: 4,
	maximumHours: 8.5,
	childHourDiscounts: {
		1: 1,
		2: 0.5,
		3: 0,
	},
	foodCostBreakfast: 2956,
	foodCostLunch: 5783,
	foodCostMidday: 2956,
};

Leikskolagjold.formatPrice = function(price) {
	return new Intl.NumberFormat('de-DE', { style: 'currency', currency: 'ISK' }).format(price);
};

Leikskolagjold.calculate = function() {
	const results = {};
	let totalTimeCost = 0;
	let totalFoodCost = 0;

	Leikskolagjold.readInputs();
	if (Leikskolagjold.hours > 0 && Leikskolagjold.children > 0) {
		results.children = [];

		for (let child = 1; child <= Leikskolagjold.children; child++) {
			const time = Leikskolagjold.calculateTime(child);
			const food = Leikskolagjold.calculateFood();
			const totalCost = time.totalCost + food.totalCost;

			totalTimeCost += time.totalCost;
			totalFoodCost += food.totalCost;

			results.children.push({
				child,
				time,
				food,
				totalCost,
			});
		}
		results.totalCost = totalTimeCost + totalFoodCost;

		Leikskolagjold.renderResults(results);
	}
};

Leikskolagjold.readInputs = function() {
	Leikskolagjold.hours = $('#leikskolagjoldHours').val();
	Leikskolagjold.children = $('#leikskolagjoldChildren').val();
	Leikskolagjold.subsidized = $('#leikskolagjoldSubsidized').is(':checked');
	Leikskolagjold.skipBreakfast = $('#leikskolagjoldSkipBreakfast').is(':checked');
};

Leikskolagjold.renderResults = function(results) {
	let html = '<h4>Niðurstöður</h4>';

	results.children.forEach((child) => {
		html += '<h5>Barn '+child.child+'</h5>';
		html += '<div>Dvalargjald: '+Leikskolagjold.formatPrice(child.time.timeCost)+'</div>';

		if (child.time.priceRatio < 1) {
			html += '<div>Systkinaafsláttur: -'+Leikskolagjold.formatPrice(child.time.discounted)+'</div>';
			html += '<div>Dvalargjald eftir afslátt: '+Leikskolagjold.formatPrice(child.time.totalCost)+'</div>';
		}
		html += '<div>Fæðisgjald: '+Leikskolagjold.formatPrice(child.food.totalCost)+'</div>';
		html += '<div><b>Samtals:</b> '+Leikskolagjold.formatPrice(child.totalCost)+'</div>';
		html += '<div>&nbsp;</div>';
	});

	html += '<h5>Samtals: '+Leikskolagjold.formatPrice(results.totalCost)+'</h5>';

	$('#leikskolagjoldResults').html(html);
};

Leikskolagjold.calculateTime = function(childNumber) {
	let timeCost = 0;
	if (Leikskolagjold.subsidized) {
		timeCost = Leikskolagjold.const.hourCostSubsidized * Leikskolagjold.hours;
	}
	else {
		timeCost = Leikskolagjold.const.hourCostNormal * Leikskolagjold.hours;
	}

	let discountTier = childNumber;
	if (childNumber > 1 && Leikskolagjold.const.childHourDiscounts[childNumber] === undefined) {
		discountTier = Object.entries(Leikskolagjold.const.childHourDiscounts).length;
	}

	const priceRatio = Leikskolagjold.const.childHourDiscounts[discountTier];
	const totalCost = Math.ceil(timeCost * priceRatio);
	const discounted = timeCost - totalCost;

	return {
		timeCost,
		discountTier,
		priceRatio,
		discounted,
		totalCost,
	};
}

Leikskolagjold.calculateFood = function() {
	const results = {};
	let totalCost = 0;

	if (Leikskolagjold.skipBreakfast === false || (Leikskolagjold.skipBreakfast && Leikskolagjold.hours > 7)) {
		totalCost += Leikskolagjold.const.foodCostBreakfast;
		results.foodCostBreakfast = Leikskolagjold.const.foodCostBreakfast;
	}

	// Add lunch
	totalCost += Leikskolagjold.const.foodCostLunch;
	results.foodCostLunch = Leikskolagjold.const.foodCostLunch;

	// Add midday
	totalCost += Leikskolagjold.const.foodCostMidday;
	results.foodCostMidday = Leikskolagjold.const.foodCostMidday;

	results.totalCost = totalCost;
	return results;
}
